export interface RoomNavigationConfig {
  title: string;
  hasHistorySection: boolean;
  hasTopSection: boolean;
  howPlaySection: boolean;
}
